import React from 'react';
import './Mision.css';
import misionFoto from '../Imagenes/mision_foto.jpeg';

const Funciones = () => (
  <main className="mision-page">
    <section className="mision-hero" style={{ backgroundImage: `url(${misionFoto})` }}>
      <div className="mision-hero-overlay" />
      <div className="mision-container mision-hero-content reveal-on-scroll">
        <h1>Funciones</h1>
        <p>
          Principales lineas de accion para el control, aprovechamiento y proteccion de los
          recursos hidricos provinciales.
        </p>
      </div>
    </section>

    <section className="mision-content">
      <div className="mision-container mision-cards single">
        <article className="mision-card reveal-on-scroll">
          <p>
            Efectuar los estudios generales mediatos e inmediatos de obras para captación y distribución del agua, tanto de superficie como subterráneas de la Provincia para el consumo humano.</p>
<p>Elaborar planes de corto, mediano y largo alcance para el logro de su misión.</p>
 

<p>Ejercer el control con pleno ejercicio del Poder de Policía, sobre los trabajos de cualquier índole que se ejecuten en los sistemas hidráulicos de la Provincia, en coordinación con los organismos competentes, emitiendo los instrumentos correspondientes de factibilidad técnica.</p>
 

<p>Estudiar lo relativo al aprovechamiento del agua para la producción de energía, como también, las obras de desagües pluviales en toda la Provincia.</p>
 

<p>Formular los estudios y proyectos para ejecutar obras hidráulicas en el ámbito de la Provincia, por administración y/o por contratos a terceros y por convenio con instituciones públicas o privadas.</p>
 

<p>Supervisar la elaboración de los pliegos generales y particulares, de las obras a ejecutar por terceros, conforme a las normas legales vigentes.</p>
 

<p>Entender en la fiscalización de todas las obras que se ejecuten por contrato, emitiendo los certificados de obras, de adicionales e imprevistos, de redeterminación de precios, así como realizar las recepciones provisorias y definitivas de obras, verificando los plazos de garantía.</p>
 

<p>Ejecutar las Obras por Administración, controlando las inversiones que se efectúen tanto en relación a los elementos materiales como humanos.</p>
 

<p>Entender en el mantenimiento y conservación de  los equipos del organismo, para la ejecución de las Obras por Administración o para su alquiler a terceros, de acuerdo a las normas legales vigentes.</p>
 

<p>Registrar la información permanentemente actualizada sobre los perfiles geológicos de los pozos perforados, por el Estado Provincial o terceros y habilitados en el ámbito de la Provincia, en coordinación con los organismos competentes en la materia.</p>
 

<p>Conservar, mantener y reparar todas las obras del ámbito de su competencia.</p>
 

<p>Participar en la evaluación de impactos ambientales, en el marco de su incumbencia, articuladamente con los organismos que correspondan.</p>
 

<p>Coordinar las acciones relacionadas con la formulación, ejecución y seguimiento de la “Política Hídrica de la Provincia”.</p>
 

<p>Coordinar la elaboración y utilización de la cartografía básica de la Provincia.</p>
 

<p>Propiciar y coordinar con quien corresponda, el ordenamiento territorial, para garantizar la optimización de los recursos hídricos.</p>

<p>Participar en los consejos y comités ínterjurisdiccionales sobre cuencas hídricas.</p>
 

<p>Realizar el seguimiento de las gestiones y trámites para obtención de la financiación de obras, en los organismos Nacionales o Provinciales que correspondan, en el ámbito de su competencia.</p>
          
        </article>
      </div>
    </section>
  </main>
);

export default Funciones;

